import { useOptimizelyStore } from "./OptimizelyStore";
import type { ExperimentConfig, OptimizelyEvent, OptimizelyStoreProps, OptimizelyPushEvent } from "./OptimizelyStore.d";

export { useOptimizelyStore };
export type { ExperimentConfig, OptimizelyEvent, OptimizelyStoreProps, OptimizelyPushEvent };
